export default `
	query listScheduleItems($docId:ID!, $startDate:AWSDateTime, $endDate:AWSDateTime){
			listScheduleItems(docId:$docId, startDate:$startDate, endDate:$endDate){
				items{
					docId
					creationTimestamp
					itemId
					fromTimestamp
					toTimestamp
					clinic
					type
					pharmacyRemarks
					doctorRemarks
					patient{
						name{
							firstName
							lastName
						}
						idCard
						dob
						email
						mobile{
							countryPrefixCode
							mobileNumber
						}
						landline{
							countryPrefixCode
							landlineNumber
						}
						remindManually
					}
					billing{
						doctorRate
						clinicFee
						toBePaidAt
						services{
							price
							bought
							currency
							title
						}
					}
				}
			}
		}
	`